import Swal from 'sweetalert2'

export default {
  emptySelectOptionText: '-- не выбрано --',
  validatorMessageEmpty: 'Введите данные',
  pageSize: 10,
  messengerFileLimit: 10,
  messengerFileMaxSize: 4 * 1048576,//4мб
  confirmOptions: {
    delete: {
      title: 'Удаление',
      text: 'Вы действительно хотите удалить эту запись?',
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      showCancelButton: true,
      icon: 'warning',
    }
  },
  yesNoList: [{
    id: null, text: '-- не выбрано --'
  }, {
    id: true, text: 'Да'
  }, {
    id: false, text: 'Нет'
  }],
  phoneInputMask: '+7 (99999) 999-99',
  SystemDialogType: 4,
  CuratorDialogType: 2,
  //SystemDialogId: 1,
  // Permission IDs
  ViewSystemMessages: 83,
  OrgServicesChat: 85,
  alert: Swal.mixin({
    //customClass: {
    //  confirmButton: 'btn btn-success',
    //  cancelButton: 'btn btn-danger'
    //},
    //buttonsStyling: false
  }),
};
